export default {
    analysisTools: 'Other tools',
    collapse: 'Collapse',
    expand: 'Expand',
    display: 'Display',
    customAnalysis: 'Custom analysis',
    automaticInsights: 'Automatic insights',
    insightsAndAlerts: 'Insights and Alerts',
    dashboards: 'Dashboards',
    settings: 'Settings',
}
